import { useI18n } from '@/features/i18n/I18nProvider';

export function LocaleToggle({ className }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <div className={className ? `locale-toggle ${className}` : 'locale-toggle'} role="group" aria-label="Language">
      <button
        type="button"
        className={`btn btn-ghost${locale === 'fr' ? ' is-active' : ''}`}
        onClick={() => setLocale('fr')}
      >
        {t('lang.fr')}
      </button>
      <button
        type="button"
        className={`btn btn-ghost${locale === 'en' ? ' is-active' : ''}`}
        onClick={() => setLocale('en')}
      >
        {t('lang.en')}
      </button>
    </div>
  );
}
